import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import ShowValue from '../../components/ShowValue';
import MessageModal from '../Message';
import AuthService from '../../utils/auth.service';

class Navbar extends Component {
  authService = AuthService;
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      currentUser: {},
      profile: {},
      emailMessage: '',
      messageModal: {
        open: false,
        title: '',
        message: ''
      }
    };

    document.addEventListener('messageModal', data => {
      if (data.detail) {
        let message = data.detail;
        message.open = true;
        this.setState(...this.state, { messageModal: message });
      }
    });

    document.addEventListener('firebaseLogin', data => {
      if (data.detail) {
        this.setState(...this.state, { currentUser: data.detail.registerData });
      }
    });

    document.addEventListener('profileLoaded', (data) => {
      if (data.detail) {
        this.setState(...this.state, {
          currentUser: data.detail.registerData,
          profile: data.detail.profile,
          emailMessage: `mailto:henrique@cryptolands.io?subject=Hello! This is ${data.detail.profile.name}, I'd like to get in touch...&body=Hello Cryptolands.io team, %0D`
          // emailMessage: `mailto:contact@cryptolands.io?subject=Hello! This is ${data.detail.profile.name}, I'd like to get in touch...&body=Hello Cryptolands.io team, %0D`
        });
      }
    });

    document.addEventListener('profileLogout', (data) => {
      if (data.detail) {
        this.setState(...this.state, {
          currentUser: data.detail.registerData,
          profile: data.detail.profile
        });
      }
    });

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    this.setState(...this.state, { dropdownOpen: !this.state.dropdownOpen });
  }

  toggleMessageModal() {
    this.setState(...this.state, { messageModal: { open: !this.state.messageModal.open } });
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <h3 className="navbar-brand-text">
              Cryptolands.i<img src="/assets/images/sun.jpg" alt="sun" />
            </h3>
          </Link> {/* Cryptolands to Main */}

          <ul className="navbar-nav ml-auto">
            <li className="nav-item" hidden={this.state.currentUser.uid}>
              <button className="nav-link google-login" onClick={this.login}>
                <img className="google-img" width="20" alt="Logo Google" src="/assets/images/logo-google.png" />
                <span className="google-text">Log in</span>
              </button>
            </li> {/* Login button */}

            <li className="nav-item">
              <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} hidden={!this.state.currentUser.uid}>

                <DropdownToggle caret>
                  <img className="profile-picture" src={this.state.currentUser.photoURL} alt="personal" />
                  {this.state.profile.name}
                  <span className="profile-btc" hidden={this.state.profile.btc_founds === undefined || this.state.profile.btc_founds !== this.state.profile.btc_balance}>
                    <ShowValue withoutBreak="true" btc={this.state.profile.btc_founds - this.state.profile.reserved_auction} />
                  </span> {/* Net Balance */}
                  <span className="profile-btc" hidden={this.state.profile.btc_founds !== undefined}> Loading... </span>{/* Loading */}
                  <span className="profile-btc" hidden={this.state.profile.btc_founds === this.state.profile.btc_balance}> Waiting for Blockchain... </span>{/* Waiting */}
                </DropdownToggle>

                <DropdownMenu>

                  <DropdownItem>
                    <Link to="/profile">
                      <i className="far fa-user mr-2"></i> Profile
                    </Link>
                  </DropdownItem> {/* Profile */}

                  <DropdownItem>
                    <Link to="/profile/wallet">
                      <i className="fab fa-bitcoin mr-2"></i> Wallet
                    </Link>
                  </DropdownItem> {/* Wallet */}

                  <DropdownItem>
                    <Link to="/profile/security">
                      <i className="fas fa-shield mr-2"></i> Security
                    </Link>
                  </DropdownItem> {/* Security */}

                  <DropdownItem>

                    <a href={this.state.emailMessage}>
                      <i className="fas fa-question mr-2"></i>Email us...
                    </a>
                  </DropdownItem> { /* Help */}

                  <DropdownItem className="dropdown-item-custom" onClick={this.logout}>
                    <i className="fas fa-sign-out-alt mr-2"></i>
                    Logout
                   </DropdownItem> {/* Logout */}
                </DropdownMenu>

              </Dropdown>
            </li> {/* Dropdown */}
          </ul>
        </div>
        <MessageModal message={this.state.messageModal.message} title={this.state.messageModal.title} toggle={this.toggleMessageModal} isOpen={this.state.messageModal.open} />
      </nav>
    );
  }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Main/navbar.js